import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import ServiceCard from "../components/ServiceCard";
import { services } from "../data/services";
import { ArrowRight } from "lucide-react";

export default function ServicesIndex() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: services.map((s, i) => ({
      "@type": "ListItem",
      position: i + 1,
      url: `https://kandkassociates.com/services/${s.slug}`,
      name: s.title,
    })),
  };

  return (
    <>
      <SEO
        title="Practice Areas — 30 Legal Services"
        description="Explore K & K Associates' 30 practice areas — Litigation, Intellectual Property, Arbitration, Contract Drafting, M&A, Real Estate, Consumer Protection, SARFAESI, Debt Recovery, Banking & Finance, White Collar Crimes, Companies Act & NCLT, Matrimonial, PIL, Startup Advisory and more."
        canonical="https://kandkassociates.com/services"
        keywords={["practice areas Delhi law firm", "legal services India", "advocate services Defence Colony"]}
        schema={schema}
      />

      {/* Hero */}
      <section className="pt-28 md:pt-40 pb-14 md:pb-20 bg-paper border-b border-rule">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <p className="kicker mb-6">Practice Areas</p>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
            <h1 className="lg:col-span-8 font-display text-4xl sm:text-5xl md:text-6xl xl:text-7xl leading-[1] sm:leading-[0.98] text-ink">
              Thirty practice areas.<br/>
              <span className="italic text-brand">A single, disciplined firm.</span>
            </h1>
            <p className="lg:col-span-4 font-serif text-lg text-ink/70 leading-relaxed">
              From boardroom advisory to constitutional bench advocacy — every domain of law a modern enterprise or individual encounters, handled in one place.
            </p>
          </div>
        </div>
      </section>

      {/* Editorial grid of all 22 services */}
      <section className="bg-bone py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-rule">
            {services.map((s, i) => (
              <div key={s.slug} className="border-r border-b border-rule">
                <ServiceCard service={s} index={i} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 md:py-20 bg-paper">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-12 text-center">
          <h2 className="font-display text-3xl md:text-5xl leading-tight text-ink">
            Don't see your matter listed?
          </h2>
          <p className="mt-6 font-serif text-xl text-ink/70 max-w-2xl mx-auto">
            Write to us. If it is law, we have likely handled something close to it.
          </p>
          <div className="mt-10">
            <Link to="/contact" className="btn-primary" data-testid="services-cta-contact">
              Speak with a Partner <ArrowRight className="w-3.5 h-3.5" strokeWidth={1.5} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
